export const getBikeState = (bike) => {
  let label;
  if (!bike.is_available) {
    if (!bike.rents_in_progress) {
      label = 'Perdu ';
    } else {
      label = 'En location ';
    }
  } else if (!bike.is_activate) {
    label = 'Désactivé ';
  } else {
    label = 'Disponible ';
  }
  return label;
};



// WEBPACK FOOTER //
// ./src/services/BikeService.js